module.exports = __webpack_public_path__ + "img/mediterranean-soup.2f906c27.jpg";